module.exports = __webpack_public_path__ + "static/media/298450.c119cb28.png";